import { EnumFunctions } from "@/shared/utils/constants";
import i18n from "@/libraries/i18n";

const { t } = i18n;

export const RequestStatus = {
  PENDING: {
    value: "PENDING",
    label: "Pending",
  },
  REVISION_NEEDED: {
    value: "REVISION_NEEDED",
    label: "Revision needed",
  },
  EXPIRED: {
    value: "EXPIRED",
    label: "Expired",
  },
  SUBMITTED: {
    value: "SUBMITTED",
    label: "Submitted",
  },
  ...EnumFunctions,
};

export const RequestStatuses = {
  [RequestStatus.EXPIRED.value]: t("datablocks.requestStatus.expired"),
  [RequestStatus.PENDING.value]: t("datablocks.requestStatus.pending"),
  [RequestStatus.REVISION_NEEDED.value]: t(
    "datablocks.requestStatus.revision_needed",
  ),
  [RequestStatus.SUBMITTED.value]: t("datablocks.requestStatus.submitted"),
};
